import { Module, VuexModule, Mutation, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { File } from '@/app/shared/models';

@Module({
  namespaced: true,
  name: 'fileBank',
  store,
  dynamic: true
})
class FileBankStoreModule extends VuexModule {
  public files: File[] = [];

  @Mutation
  public setFile(value: File[]): void {
    this.files = value;
  }
}

export default getModule(FileBankStoreModule);
